<template>
    <section class="notification-item">
        <section class="notification-item__icon">
            <img src="@/assets/icons/components/error-alert.svg" />
        </section>
        <section class="notification-item__body">
            <section class="notification-item__body__title">
                {{$t('com.file.header-user-info.email-not-confirm')}}
            </section>
            <section class="notification-item__body__description">
                <p>{{$t('com.file.profile.send-activation-link-info')}}</p>
                <section class="notification-item--center">
                    <button class="notification-item__button notification-item__button--small notification-item__button--white"
                            @click="() => this.$store.commit('toggleNoEmailConfirmDetails', true)">
                        <span class="notification-item__button__text">{{$t('com.file.not-email-confirmed.check-details')}}</span>
                    </button>
                </section>
            </section>
        </section>
        <Transition>
            <NoEmailConfirmedDetails v-if="isShowDetails"/>
        </Transition>
    </section>
</template>
<script charset="utf-8">
    import NoEmailConfirmedDetails from "./Modals/NoEmailConfirmedDetails.vue";
    export default {
        name: "NoEmailConfirmed",
        components: {
            NoEmailConfirmedDetails
        },
        data() {
            return {
                isOpenDetails: false
            }
        },
        computed: {
            isShowDetails(){
                return this.$store.state.appStore.isShowNoEmailConfirmDetails;
            }
        },
    }
</script>
<style lang="scss" scoped>
    @use '@/assets/scss/notification-item.scss';
</style>